import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "@mui/material";
import { Edge } from "@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/dist/types/types";
import { TreeItem } from "../../../data/tree";

export interface DropIndicatorPageCustomProps {
  edge?: Edge; // Adicione outras posições, se necessário
  item: TreeItem;
}

const DropIndicatorPageCustom: React.FC<DropIndicatorPageCustomProps> = ({
  edge,
  item,
}) => {
  const theme = useTheme();
  const indicatorRef = useRef<HTMLDivElement>(null);

  // if (!edge) {
  //   return null; // Não renderiza nada se o indicador não deve ser exibido
  // }

  const styles = {
    base: {
      position: "absolute" as const,
      height: "2px",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "2px",
      // margin: edge === "top" ? "0 0 4px 0" : "4px 0 0 0",
    },
    left: {
      left: "-9px", // Distância à esquerda do botão
      top: "0",
      bottom: "0",
      width: "2px",
      height: "100%",
    },
    right: {
      right: "-9px", // Distância à direita do botão
      top: "0",
      bottom: "0",
      width: "2px",
      height: "100%",
    },
  };

  return (
    <div
      ref={indicatorRef}
      style={{
        display: edge ? "flex" : "none",
        ...styles.base,
        ...(edge !== "bottom" && edge !== "top" && edge
          ? styles[edge]
          : styles.base),
      }}
    >
      {edge + " " + item.title}
    </div>
  );
};

export default DropIndicatorPageCustom;
